import type { SxProps, Theme } from "@mui/system";

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75rem 1rem",
    width: "100%",
  },
  leftControls: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
  },
  buttonGroup: {
    display: "flex",
    gap: "0.5rem",
  },
  iconButtons: {
    display: "flex",
    gap: "0.25rem",
  },
  emptyState: {
    textAlign: "center",
    marginTop: "1rem",
    fontSize: "14px",
    color: "#888",
  },
};
